// src/Theme/theme.js
import { createTheme } from "@mui/material/styles";

const theme = createTheme({
  palette: {
    primary: {
      main: "#D35400", // Burnt Orange
    },
    secondary: {
      main: "#2C3E50", // Deep Blue Gray
    },
    background: {
      default: "#F5F5F5", // Light Background
    },
  },
  typography: {
    fontFamily: "Roboto, Arial, sans-serif",
  },
  components: {
    MuiDataGrid: {
      styleOverrides: {
        root: {
          "& .MuiDataGrid-row:nth-of-type(even)": {
            backgroundColor: "#F8F9FA",
          },
          "& .MuiDataGrid-row:nth-of-type(odd)": {
            backgroundColor: "#FFFFFF",
          },
          "& .MuiDataGrid-row:hover": {
            backgroundColor: "#E0E0E0 !important",
            transition: "background-color 0.3s ease-in-out",
          },
        },
      },
    },
  },
  // ✅ Custom Styles for Layout
  layout: {
    mainContainer: {
      minHeight: "100vh",
      background: "linear-gradient(to right, #f4f4f4, #e0e0e0)",
      padding: 3,
    },
  },
});

export default theme;
